export enum AssetDepreciationMonthsCalculationType {
MonthIsCounted,
MonthIsAlwaysCounted,
MonthIsNeverCounted,
}
